(function () {
  'use strict';

  var UNIVERSAL_VALUE = 'Universal';
  var initialized = false;

  var ICONS = {
    match: '<path d="m5 12 4 4L19 6"></path>',
    universal: '<path d="m5 12 4 4L19 6"></path>',
    mismatch: '<path d="M18 6 6 18M6 6l12 12"></path>',
    unknown: '<circle cx="12" cy="12" r="9"></circle><path d="M12 11v5M12 8h.01"></path>',
    none: '<path d="M3 15.5V12l2.1-4.1A2 2 0 0 1 6.9 6.8h10.2a2 2 0 0 1 1.8 1.1L21 12v3.5"></path><path d="M5 12h14M5 15.5h14"></path><circle cx="6.5" cy="15.5" r="1.5"></circle><circle cx="17.5" cy="15.5" r="1.5"></circle>'
  };

  function parseModels(root) {
    var raw = root.getAttribute('data-product-models');

    if (!raw) {
      return [];
    }

    try {
      var parsed = JSON.parse(raw);

      if (Array.isArray(parsed)) {
        return parsed
          .map(function (model) {
            return String(model || '').trim();
          })
          .filter(Boolean);
      }

      if (parsed) {
        return [String(parsed).trim()].filter(Boolean);
      }
    } catch (error) {
      console.warn(
        '[LCM Product Fitment] Invalid product model data ignored.',
        error
      );
    }

    return [];
  }

  function getActiveVehicle() {
    if (
      !window.LCMVehicle ||
      typeof window.LCMVehicle.getActive !== 'function'
    ) {
      return null;
    }

    return window.LCMVehicle.getActive();
  }

  function getFitmentState(models, activeVehicle) {
    if (models.indexOf(UNIVERSAL_VALUE) !== -1) {
      return 'universal';
    }

    if (models.length === 0) {
      return 'unknown';
    }

    if (!activeVehicle) {
      return 'none';
    }

    if (models.indexOf(activeVehicle.model) !== -1) {
      return 'match';
    }

    return 'mismatch';
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [vehicle.make, vehicle.model].filter(Boolean).join(' ');
  }

  function replaceToken(text, token, value) {
    return String(text || '').split(token).join(value || '');
  }

  function closePicker(root) {
    var mount = root.querySelector(
      '[data-lcm-product-fitment-picker-mount]'
    );
    var toggle = root.querySelector(
      '[data-lcm-product-fitment-toggle]'
    );
    var label = root.querySelector(
      '[data-lcm-product-fitment-toggle-label]'
    );

    if (mount) {
      mount.hidden = true;
    }

    root.classList.remove('is-picker-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    if (label) {
      label.textContent = getActiveVehicle()
        ? root.dataset.labelChange
        : root.dataset.labelChoose;
    }
  }

  function renderRoot(root) {
    var models = parseModels(root);
    var activeVehicle = getActiveVehicle();
    var state = getFitmentState(models, activeVehicle);
    var vehicle = vehicleLabel(activeVehicle);

    var modelsLabel = models
      .filter(function (model) {
        return model !== UNIVERSAL_VALUE;
      })
      .join(', ');

    var title =
      root.dataset['text' + capitalize(state) + 'Title'] || '';

    var description =
      root.dataset['text' + capitalize(state) + 'Description'] || '';

    title = replaceToken(title, '[vehicle]', vehicle);
    description = replaceToken(
      description,
      '[vehicle]',
      vehicle
    );
    description = replaceToken(
      description,
      '[models]',
      modelsLabel
    );

    root.dataset.fitmentState = state;

    root.querySelector(
      '[data-lcm-fitment-title]'
    ).textContent = title;

    root.querySelector(
      '[data-lcm-fitment-description]'
    ).textContent = description;

    var icon = root.querySelector(
      '[data-lcm-fitment-icon]'
    );

    if (icon) {
      icon.innerHTML = ICONS[state] || ICONS.unknown;
    }

    var label = root.querySelector(
      '[data-lcm-product-fitment-toggle-label]'
    );

    if (
      label &&
      !root.classList.contains('is-picker-open')
    ) {
      label.textContent = activeVehicle
        ? root.dataset.labelChange
        : root.dataset.labelChoose;
    }

    root.hidden = false;
  }

  function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function renderAll() {
    document
      .querySelectorAll('[data-lcm-product-fitment]')
      .forEach(renderRoot);
  }

  function getConfiguredPicker() {
    /*
     * Voorkeur:
     * gebruik de expliciet gemarkeerde voertuigselector.
     */
    var source = document.querySelector(
      '[data-lcm-vehicle-picker-source]'
    );

    if (source) {
      var configuredQuickFilter = source.querySelector(
        'quick-filter[data-mode="filter"]'
      );

      if (configuredQuickFilter) {
        return {
          source: source,
          quickFilter: configuredQuickFilter
        };
      }
    }

    /*
     * Fallback:
     * zoek de Quick Filter in de producttemplate en sla
     * de voertuigselector in de header bewust over.
     */
    var candidates = document.querySelectorAll(
      'quick-filter[data-mode="filter"]'
    );

    for (
      var index = 0;
      index < candidates.length;
      index += 1
    ) {
      var quickFilter = candidates[index];

      /*
       * Een reeds gemonteerde selector nooit opnieuw
       * verplaatsen.
       */
      if (
        quickFilter.closest(
          '[data-lcm-product-fitment]'
        )
      ) {
        continue;
      }

      /*
       * De voertuigselector in de header moet intact blijven.
       */
      if (
        quickFilter.closest('.lcm-header-garage') ||
        quickFilter.closest(
          '.shopify-section[id*="__header"]'
        )
      ) {
        continue;
      }

      var fallbackSource =
        quickFilter.closest('.shopify-section') ||
        quickFilter.parentElement;

      if (fallbackSource) {
        return {
          source: fallbackSource,
          quickFilter: quickFilter
        };
      }
    }

    return null;
  }

  function mountPicker(root) {
    var mount = root.querySelector(
      '[data-lcm-product-fitment-picker-mount]'
    );

    if (!mount) {
      return null;
    }

    var existing = mount.querySelector(
      'quick-filter[data-mode="filter"]'
    );

    if (existing) {
      return existing;
    }

    var configured = getConfiguredPicker();

    if (!configured) {
      console.warn(
        '[LCM Product Fitment] No configured vehicle picker source found on this product template.'
      );

      return null;
    }

    configured.source.hidden = true;
    configured.source.style.display = 'none';
    configured.source.setAttribute(
      'aria-hidden',
      'true'
    );

    mount.appendChild(configured.quickFilter);

    return configured.quickFilter;
  }

  function togglePicker(root) {
    var mount = root.querySelector(
      '[data-lcm-product-fitment-picker-mount]'
    );
    var toggle = root.querySelector(
      '[data-lcm-product-fitment-toggle]'
    );
    var label = root.querySelector(
      '[data-lcm-product-fitment-toggle-label]'
    );

    if (!mount || !mountPicker(root)) {
      return;
    }

    var open = mount.hidden;

    mount.hidden = !open;
    root.classList.toggle(
      'is-picker-open',
      open
    );

    if (toggle) {
      toggle.setAttribute(
        'aria-expanded',
        String(open)
      );
    }

    if (label) {
      label.textContent = open
        ? root.dataset.labelClose
        : getActiveVehicle()
          ? root.dataset.labelChange
          : root.dataset.labelChoose;
    }
  }

  function bindEvents() {
    document.addEventListener(
      'click',
      function (event) {
        var toggle = event.target.closest(
          '[data-lcm-product-fitment-toggle]'
        );

        if (!toggle) {
          return;
        }

        var root = toggle.closest(
          '[data-lcm-product-fitment]'
        );

        if (root) {
          togglePicker(root);
        }
      }
    );

    window.addEventListener(
      'lcm:vehiclechange',
      function () {
        document
          .querySelectorAll(
            '[data-lcm-product-fitment]'
          )
          .forEach(function (root) {
            renderRoot(root);
            closePicker(root);
          });
      }
    );

    document.addEventListener(
      'shopify:section:load',
      renderAll
    );
  }

  function init() {
    if (!initialized) {
      initialized = true;
      bindEvents();
    }

    renderAll();

    if (!window.LCMVehicle) {
      var attempts = 0;

      var timer = window.setInterval(
        function () {
          attempts += 1;

          if (
            window.LCMVehicle ||
            attempts >= 100
          ) {
            window.clearInterval(timer);
            renderAll();
          }
        },
        50
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();